import { norecord } from "src/assets/images";
import { orderpic } from "src/assets/images";
import AllProducts from "./ProductCategories/AllProducts";
import { useQuery } from "@tanstack/react-query";
import { getOrders } from "src/api";
import ReactPaginate from 'react-paginate';
import { useState } from "react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa"; // Import icons
import { renderCurrency } from "./renderCurrency";


const AccountOrders = () => {
    const [currentPage, setCurrentPage] = useState(1); //
    // Change to false to see the "No Records" message


    const { data } = useQuery({
        queryKey: ["getorders", currentPage], // Ensure re-fetch when page changes
        queryFn: () => getOrders(currentPage),
        keepPreviousData: true, // Avoid empty states between page changes
    });
    // console.log("getOrders", data);

    // Function to handle page change
    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected + 1);

    };

    return (
        <div>
            <div>
                {data?.data?.length === 0 ? ( // Check if there are no orders
                    <div className="fatix-no-records-div flex justify-center items-center">
                        <img src={norecord} alt="No Records" className="w-120 h-30" />
                    </div>
                ) : (
                    <div className="grid grid-cols-1 gap-[70px]">
                        {data?.data?.map((order) =>
                            order.orderItems.map((orderItem) => (
                                <div key={orderItem.item.id} className="col-span-1 bg-white rounded-lg">
                                    <div className="flex items-center justify-between status-pending-fatix">
                                        {/* Product Image (Left) */}
                                        <img src={orderItem.item?.itemImages.length > 0 ? (orderItem.item?.itemImages[0].url) : orderpic} alt="Product" className="h-[150px] w-[150px] object-cover rounded-lg" />
                                        {/* Order Details (Middle) */}
                                        <div className="flex-1 text-center px-4">
                                            <h3 className="text-lg font-semibold">Design Number: {orderItem.item.design_number}</h3>
                                            <p className="text-gray-500">Amount: {renderCurrency(order.price)}</p>
                                        </div>

                                        {/* Order Status (Right) */}
                                        <div className="text-right sandule-values">
                                            <p className="text-green-500 font-semibold">Status: <span>{order?.status}</span></p>
                                            <p className="text-gray-500">Date: {new Date(order?.updatedAt).toLocaleDateString()}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                        <ReactPaginate
                            previousLabel={<FaArrowLeft />}
                            previousClassName="previous-class"
                            nextLabel={<FaArrowRight />}
                            nextClassName="next-class"
                            pageCount={data?.data ? data?.meta?.totalItems / data?.meta?.itemsPerPage : 0} // Assuming each page returns 10 items
                            onPageChange={handlePageChange}
                            containerClassName={"pagination"}
                            activeClassName={"active-paginate"}
                            renderOnZeroPageCount={null}
                            breakLabel="..."
                        />
                    </div>

                )}
            </div>

            <div className="mt-[50px]">
                <h4 className="browse-fatix-heading">Browse Products</h4>
                <AllProducts />
            </div>
        </div>
    );
};

export default AccountOrders;
